import {StyleSheet, Text, View} from 'react-native'

import {getTheme} from '#/themes/registry'
import {type ThemePlayerProps} from '#/types/capsule'

interface Props extends ThemePlayerProps {
  mode?: 'play' | 'preview' | 'creator'
}

export function ThemeRenderer({mode = 'play', ...props}: Props) {
  let Component
  try {
    const theme = getTheme(props.capsule.themeId)
    // "preview" and "creator" both use the PreviewComponent (lighter skin).
    // "play" uses the full PlayerComponent.
    Component =
      mode === 'preview' || mode === 'creator'
        ? theme.PreviewComponent
        : theme.PlayerComponent
  } catch {
    return (
      <View style={styles.error}>
        <Text style={styles.errorText}>
          Theme "{props.capsule.themeId}" not found
        </Text>
      </View>
    )
  }
  return <Component {...props} />
}

const styles = StyleSheet.create({
  error: {flex: 1, alignItems: 'center', justifyContent: 'center', padding: 24},
  errorText: {color: '#d63031', fontSize: 14, textAlign: 'center'},
})
